import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type AddressesQueryVariables = {};


export type AddressesQuery = (
  { __typename?: 'Query' }
  & { senderRecipients: Array<(
    { __typename?: 'SenderRecipient' }
    & Pick<Types.SenderRecipient, '_id' | 'supplierNumber' | 'countryCode' | 'name' | 'place' | 'postCode' | 'street' | 'phone' | 'inactive'>
  )> }
);

export const AddressesDocument = gql`
    query addresses {
  senderRecipients(filter: {inactive: {NEQ: true}}) {
    _id
    supplierNumber
    countryCode
    name
    place
    postCode
    street
    phone
    inactive
  }
}
    `;

    export function useAddressesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AddressesQuery, AddressesQueryVariables>) {
      return ApolloReactHooks.useQuery<AddressesQuery, AddressesQueryVariables>(AddressesDocument, baseOptions);
    };
      export function useAddressesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddressesQuery, AddressesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<AddressesQuery, AddressesQueryVariables>(AddressesDocument, baseOptions);
      };
      
export type AddressesQueryHookResult = ReturnType<typeof useAddressesQuery>;
export type AddressesQueryResult = ApolloReactCommon.QueryResult<AddressesQuery, AddressesQueryVariables>;